export default __webpack_public_path__ + "static/media/sampleProduct.373f63ff.jpg";